import React from 'react';
import { COMPLETION_EXTERIOR, COMPLETION_INTERIOR } from './constants';

const Row = ({ itemKey, label, value, onChange }) => {
  const v = value || {};
  const confirmed = !!v.confirmed;
  const toggle = () => onChange(itemKey, { ...v, confirmed: !confirmed });
  return (
    <tr className="border-b border-slate-200 last:border-b-0">
      <td className="py-2 px-3 text-sm text-slate-800">{label}</td>
      <td className="py-2 px-3 text-center">
        <button
          type="button"
          onClick={toggle}
          data-testid={`completion-${itemKey}-confirmed`}
          className={
            'inline-flex items-center justify-center min-w-[68px] px-3 py-1 rounded-md text-xs font-semibold transition ' +
            (confirmed
              ? 'bg-emerald-500 text-white hover:bg-emerald-600'
              : 'bg-slate-100 text-slate-500 hover:bg-slate-200 border border-slate-300')
          }
          aria-pressed={confirmed}
        >
          {confirmed ? 'Yes' : 'No'}
        </button>
      </td>
    </tr>
  );
};

const Subtable = ({ title, items, checklist, onChange, testid }) => (
  <div className="border border-slate-200 rounded-lg overflow-hidden bg-white" data-testid={testid}>
    <div className="bg-teal-50 text-teal-800 text-xs uppercase tracking-wider font-semibold px-3 py-2 border-b border-slate-200">
      {title}
    </div>
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead className="bg-slate-50 text-[11px] uppercase tracking-wider text-slate-500">
          <tr>
            <th className="text-left py-2 px-3 font-semibold w-3/4">Areas</th>
            <th className="text-center py-2 px-3 font-semibold w-1/4">Confirmation</th>
          </tr>
        </thead>
        <tbody>
          {items.map(([key, label]) => (
            <Row
              key={key}
              itemKey={key}
              label={label}
              value={checklist[key]}
              onChange={onChange}
            />
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

const CompletionChecklist = ({ checklist, onChange }) => {
  const map = checklist || {};
  const setItem = (key, value) => {
    const next = { ...map, [key]: value };
    // Drop empty entries to keep the payload tight.
    if (!value.confirmed) delete next[key];
    onChange(next);
  };

  return (
    <div className="space-y-4" data-testid="completion-checklist">
      <Subtable
        title="Exterior"
        items={COMPLETION_EXTERIOR}
        checklist={map}
        onChange={setItem}
        testid="completion-exterior-table"
      />
      <Subtable
        title="Interiors"
        items={COMPLETION_INTERIOR}
        checklist={map}
        onChange={setItem}
        testid="completion-interior-table"
      />
    </div>
  );
};

export default CompletionChecklist;
